export const modelsData = [
    { name: "GPT-4o Mini", inCost: "$0.15", outCost: "$0.60", context: "128k", notes: "Standard fast and cost-effective model" },
    { name: "GPT-4o Azure", inCost: "$2.50", outCost: "$10.00", context: "128k", notes: "Standard flagship model" },
    { name: "GPT-4.1 Mini", inCost: "$1.10", outCost: "$4.40", context: "1M", notes: "Expanded context mini" },
    { name: "GPT-4.1", inCost: "$2.00", outCost: "$8.00", context: "1M", notes: "Expanded context flagship" },
    { name: "GPT-5 Mini", inCost: "$0.25", outCost: "$2.00", context: "200k", notes: "Next-gen mini model" },
    { name: "GPT-5.1 High", inCost: "$1.25", outCost: "$10.00", context: "200k", notes: "High reasoning capacity" },
    { name: "GPT-5.3 Chat", inCost: "$1.75", outCost: "$14.00", context: "2M", notes: "Advanced conversational reasoning (Responses API)" },
    { name: "GPT-5.4 Mini", inCost: "$0.75", outCost: "$4.50", context: "400k", notes: "Latest hyper-efficient mini (Responses API)" }
];

export default modelsData;
